import React, { useMemo } from 'react';
import size from 'lodash/size';

import styles from './commentBlock.module.css';

/**
 * Render comments and if comments are multiple then
 * parse to array
 */
function CommentBlock({ comment = '' }) {
  const displayText = useMemo(() => {
    if (!comment || comment.trim() === '') return null;

    // Normalize line breaks and split into lines
    const normalizedText = comment.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
    const lines = normalizedText.split('\n');

    const quotedLines = lines.map((line, index) => {
      if (line.trim() === '') {
        return (
          <div className={styles.lineContent} key={index}>
            &nbsp;
          </div>
        );
      }
      return (
        <div className={styles.commentLine} key={index}>
          "{line}"
        </div>
      );
    });

    return quotedLines;
  }, [comment]);

  if (!size(comment)) return null;
  return (
    <div className={styles.container}>
      <div className={styles.header}>Comments</div>
      <div className={styles.comment}>{displayText}</div>
    </div>
  );
}

export default React.memo(CommentBlock);
